import React from 'react';
import ReactDom from 'react-dom';

import App from './components/app';

const rootElement = document.getElementById("md-react-app");
if (rootElement) {
    const settings = JSON.parse(rootElement.getAttribute('data-default-settings'));
    ReactDom.render(
        <App settings={settings} />,
        document.querySelector('#md-react-app')
    );
}
